<template>
  <div
    class="post"
    :class="{ 'hide-bottom-border': hideBottomBorder }"
    @click="onRepliesClick"
  >
    <Avatar class="avatar" :name="username" />
    <div class="content">
      <div class="username">@{{ username }}</div>
      <div class="content">
        <span v-html="processedContent"></span>
      </div>
      <img
        :src="`/game-content/${gameStateKey}/social/${image}`"
        v-if="image"
      />
      <div class="buttons-container">
        <button class="replies-button" @click="onRepliesClick">
          <span class="material-icons-outlined">mode_comment</span>
          <span>{{ replies ? replies.length : "" }}</span>
        </button>
      </div>
      <div
        class="replies-container"
        :class="{ show: showReplies }"
        v-if="replies"
      >
        <SocialPost
          v-for="(post, index) in replies"
          :key="post.id"
          :hideBottomBorder="index === replies.length - 1"
          :gameStateKey="gameStateKey"
          :username="post.username"
          :content="post.content"
          :image="post.image"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from "@/components/shared/Avatar";

export default {
  name: "SocialPost",
  components: { Avatar },
  props: {
    hideBottomBorder: Boolean,
    gameStateKey: String,
    username: String,
    content: String,
    image: String,
    replies: Array,
  },
  data() {
    return {
      showReplies: false,
    };
  },
  computed: {
    processedContent() {
      let result = this.content;

      if (this.content.includes("#")) {
        let indexOfHash = this.content.indexOf("#");

        while (indexOfHash !== -1) {
          let indexOfFirstSpace = this.content.indexOf(" ", indexOfHash);
          if (indexOfFirstSpace === -1) indexOfFirstSpace = this.content.length;

          result =
            result.substring(0, indexOfHash) +
            '<span class="hashtag">' +
            result.substring(indexOfHash, indexOfFirstSpace) +
            "</span>" +
            result.substr(indexOfFirstSpace);

          indexOfHash = this.content.indexOf("#", indexOfHash + 1);
        }
      }

      return result;
    },
  },
  methods: {
    onRepliesClick() {
      this.showReplies = !this.showReplies && this.replies;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.post {
  display: flex;
  justify-content: center;
  align-items: center;

  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: rgb(56, 68, 77);

  padding: 15px;

  cursor: pointer;

  &.hide-bottom-border {
    border-bottom: none;
  }

  .avatar {
    align-self: flex-start;

    border-radius: 99999999px;

    border-style: solid;
    border-color: rgba(0, 0, 0, 0.04);
    border-width: 1px;

    margin-left: 5px;
    margin-right: 5px;
  }

  & > .content {
    flex: 1;

    & > .username {
      font-weight: bold;
      margin-bottom: 4px;
    }

    &::v-deep .content {
      white-space: pre-line;

      .hashtag {
        color: $accent-light;
      }
    }

    & > img {
      width: 100%;
      margin-top: 15px;
      border-radius: 15px;
    }

    .buttons-container {
      margin-top: 16px;

      display: flex;
      justify-content: flex-start;
      align-items: center;

      & > button {
        background: none;
        border: none;
        padding: 0px;
        color: $secondary-text-white;
        user-select: none;
        cursor: pointer;

        display: flex;
        justify-content: center;
        align-items: center;

        transition-property: opacity;
        transition-duration: 100ms;
        transition-timing-function: ease-in-out;

        &:hover {
          opacity: 0.8;
        }

        &:active {
          opacity: 0.5;
        }

        & > span {
          font-size: 1rem;
          margin-left: 8px;
        }
      }
    }

    & > .replies-container {
      transition-property: max-height, visibility;
      transition-duration: 250ms;
      transition-timing-function: ease-in-out;

      max-height: 0px;
      visibility: hidden;
      overflow: hidden;

      &.show {
        max-height: 1000px;
        visibility: visible;
      }
    }
  }
}
</style>
